import React from 'react';

const About = () => {
  return (
    <div name='about' className='w-full h-screen bg-[#f4f1de] text-[#3d405b]'>
      <div className='flex flex-col justify-center items-center w-full h-full'>
        <div className='max-w-[1000px] w-full grid grid-cols-2 gap-8'>
          <div className='sm:text-right pb-8 pl-4'>
            <p className='text-4xl font-bold inline border-b-4 border-[#e07a5f] '>
              About
            </p>
          </div>
          <div></div>
          </div>
          <div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4'>
            <div className='sm:text-right text-4xl font-bold'>
              <p className='text-[#81b29a]'>CSC Major</p>
              <p>@</p>
              <p>University of Victoria!</p>
            </div>
            <div>
              <p>I really love learning new about new technologies and building new things with them
                which is really important in today's day and age! I have worked on multiple projects 
                which include various languages and frameworks like React, Python, Java, JavaScript, Firebase, MySQL, etc!</p>  
            </div>
          </div>
      </div>
    </div>
  );
};

export default About;
